import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Modal, Button } from 'antd';
import BasicLayout from './layout/BasicLayout';
import ShopCart from './pages/shopcart/ShopCart';
import PlanList from './pages/planlist/PlanList';
import EnquiryCart from './pages/enquiry/cart';
import TransferOrder from './pages/transferOrder/index';
import PlanTransferOrder from './pages/transferOrder/plan';
import ProductDetail from './pages/productdetail/ProductDetail';
import SubmitOrder from './pages/submit/SubmitOrder';
import PlanSubmitOrder from './pages/submit/PlanSubmitOrder';
import QuotationOrder from './pages/transferOrder/QuotationOrder';
import QuotationSubmitOrder from './pages/submit/QuotationSubmitOrder';
import SubmitOrderResult from './pages/submit/SubmitOrderResult';
import User from './pages/user/User';
import Home from './pages/home/Home';
import Index from './pages/index/index';
import Location from './pages/location/index';
import LocationDetail from './pages/location/locationDetail';
import Login from './pages/login/Login';
import ChangePassword from './pages/changePassword/index/index';
import Retrieve from './pages/retrieve/index/index';
import emitter from './util/emitter';
import QuotationSearch from './pages/quotationProduct/QuotationSearch';
import QuotationEdit from './pages/quotationProduct/QuotationEdit';
import QuotationDetail from './pages/quotationProduct/QuotationDetail';
// import ProposalCart from './pages/proposal/cart';
import ProposalSubmit from './pages/proposal/submit';
import EnquirySubmit from './pages/enquiry/submit';

import QualityPrint from './pages/order/QualityPrint';
import WarehouseQualityPrint from './pages/order/warehouseQualityPrint';
import BillPrint from './pages/bill/billPrint';

const { localStorage, location } = window;
export default class Router extends React.Component {
  constructor(props) {
    super(props);
    //获取token
    const params = new URLSearchParams(window.location.search);
    const print = params.get('print');
    const urlToken = params.get('token');
    const token = localStorage.getItem('token');
    this.state = {
      loggedIn: print || !!token || !!urlToken,
      // loggedIn: true,
      visible: false,
    };
    emitter.on('authError', () => {
      localStorage.setItem('token', '');
      localStorage.setItem('userName', '');
      if (location.href && location.pathname !== '/login') {
        localStorage.setItem('preHref', location.href);
      }
      this.setState({
        visible: true,
      });
    });
    emitter.on(
      'login',
      (callback) => {
        this.setState({
          loggedIn: true,
        }, callback);
      }
    );
    emitter.on(
      'logout',
      () => {
        this.setState({
          loggedIn: false,
        });
        localStorage.removeItem('preHref');
      }
    );
  }
  componentDidMount() { }
  componentWillUnmount() {
    this.setState = () => false;
  }
  render() {
    if (!this.state.loggedIn && location.href && location.pathname !== '/login') {
      localStorage.setItem('preHref', location.href);
    }
    return (
      <React.Fragment>
        <BrowserRouter>
          {this.state.loggedIn ? (
            <Switch>
              <Route path="/basic">
                <BasicLayout>
                  <Switch>
                    {/* <Route path="/basic" exact></Route> */}
                    <Route path="/basic/home" exact component={Home}></Route>
                    <Route path="/basic/index" exact component={Index}></Route>
                    <Route path="/basic/location" exact component={Location}></Route>
                    <Route path="/basic/location/detail/:id" exact component={LocationDetail}></Route>
                    <Route path="/basic/home/:search/:type" component={Home}></Route>
                    <Route path="/basic/user" component={User}></Route>
                    <Route path="/basic/shopCart" component={ShopCart}></Route>
                    <Route path="/basic/planList" component={PlanList}></Route>
                    <Route path="/basic/enquiryCart" component={EnquiryCart}></Route>
                    <Route path="/basic/quotation" exact component={QuotationSearch}></Route>
                    <Route path="/basic/quotation/edit/:reportType/:transportation_id/:quotation_no" exact component={QuotationEdit}></Route>
                    <Route path="/basic/quotation/detail" exact component={QuotationDetail}></Route>
                    <Route path="/basic/quotation/submit" component={QuotationSubmitOrder} exact></Route>
                    <Route path="/basic/transfer/order" component={TransferOrder}></Route>
                    <Route path="/basic/transfer/plan" component={PlanTransferOrder}></Route>
                    <Route path="/basic/quotation/order" component={QuotationOrder}></Route>
                    <Route path="/basic/product/detail/:spuId/:orgId/:normsId" component={ProductDetail}></Route>
                    <Route path="/basic/submit/:type" component={SubmitOrder} exact></Route>
                    <Route path="/basic/plan/submit" component={PlanSubmitOrder} exact></Route>
                    <Route path="/basic/submit/:type/result" component={SubmitOrderResult}></Route>
                    {/* <Route path='/basic/proposalCart' component={ProposalCart} exact /> */}
                    <Route path='/basic/proposalSubmit' component={ProposalSubmit} exact />
                    <Route path='/basic/enquirySubmit' component={EnquirySubmit} exact />
                    <Redirect to="/basic/index" />
                  </Switch>
                </BasicLayout>
              </Route>
              <Route path='/billPrint/:id' component={BillPrint} exact />
              <Route path='/qualityPrint/:id' component={QualityPrint} exact />
              <Route path='/warehouseQualityPrint/:order_id/:type/:quality_id' component={WarehouseQualityPrint} exact />
              <Route path="/login" component={Login}></Route>
              <Redirect to="/basic/index" />
            </Switch>
          ) : (
            <React.Fragment>
              <Switch>
                <Route path="/login" component={Login}></Route>
                <Route path="/changePassword" component={ChangePassword}></Route>
                <Route path="/retrieve" component={Retrieve}></Route>
                <Redirect to="/login" />
              </Switch>
            </React.Fragment>
          )}
        </BrowserRouter>
        <Modal
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => { this.setState({ visible: false, loggedIn: false, }, () => window.history.pushState({}, '', '/login')); }}
            >
              确定
            </Button>,
          ]}
          closable={false}
          open={this.state.visible}
          maskClosable={false}
        >
          登录过期，请重新登录
        </Modal>
      </React.Fragment>
    );
  }
}